import {Skeleton} from '@mui/material';
import Grid from '@mui/material/Grid2';

export const ChallengeButtonsTemplate = () => (
  <>
    <Grid size={12} spacing={4} container>
      <Grid size={6}>
        <Skeleton
          variant="rectangular"
          height={47}
          sx={{borderRadius: 3, width: '100%'}}
        />
      </Grid>
      <Grid size={6}>
        <Skeleton
          variant="rectangular"
          height={47}
          sx={{borderRadius: 3, width: '100%'}}
        />
      </Grid>
    </Grid>
  </>
);
